import { Typography } from '@/components/ui/typography'
import { formatTillDate, getTillOpenAge } from '@/lib/services/cash-drawers/cash-drawers.utils'
import type { ConfigType } from 'dayjs'

// Tills can stay open across days; show how long so a forgotten drawer gets counted.
export function TillOpenSince({ openedAt }: { openedAt: ConfigType }) {
  const age = getTillOpenAge(openedAt)

  return (
    <Typography
      variant="supporting"
      tone={age.isLongOpen ? 'warning' : undefined}
      className="block"
    >
      Started {formatTillDate(openedAt)}
      {age.days > 0 ? ` · ${age.days} ${age.days === 1 ? 'day' : 'days'}` : ''}
      {age.isLongOpen ? ' · Consider counting it' : ''}
    </Typography>
  )
}
